import { KeyValueModel } from "model";
import { EnumIndIntermed } from "model/enums/enum-ind-intermed";

export const IndIntermedMock: KeyValueModel[] = [
    new KeyValueModel(EnumIndIntermed.OP_SEM_INTERMEDIADOR, 'Operação Sem Intermediador'),
    new KeyValueModel(EnumIndIntermed.OP_SITE_PLAT_TERCEIROS, 'Operação em Site ou Plataforma de Terceiros'),
]